import React from "react";
import {Button, ButtonGroup, Row} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faTrash, faUndo} from "@fortawesome/free-solid-svg-icons";
import "./DeviceActionCell.css";

const DeviceActionCell = props => (
  <Row style={{ display: "block" }}>
      <div className="floatRight">
          <ButtonGroup size="sm">
              <Button
                  className="btn-black"
                  onClick={event => {
                      event.stopPropagation();
                      props.onReset();
                  }}
              >
                  <FontAwesomeIcon icon={faUndo} size="1x" />
              </Button>

              <Button
                  className="btn-red btn-sm"
                  onClick={event => {
                      event.stopPropagation();
                      props.onDelete();
                  }}
              >
                  <FontAwesomeIcon icon={faTrash} size="1x" />
              </Button>
          </ButtonGroup>
      </div>
  </Row>
);

export default DeviceActionCell;
